export const terminalBackground = '#000000e0'
export const terminalText = '#00ff00'
